import styled from "styled-components";

export const ApplyButtonLandscape = styled.button`
  display: inline-flex;
  padding: 6px 8px;
  justify-content: flex-end;
  align-items: center;
  gap: 8.97px;
  border: 1px solid transparent;
  border-radius: 3.588px;
  background: #e7e7e7;
  color: #000;
  font-size: var(--fs-xs);
  font-weight: 500;
  width: fit-content;
`;
